"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _simplebarReact = _interopRequireDefault(require("simplebar-react"));
var _utils = require("./utils");
var _Wait = _interopRequireDefault(require("./Wait"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//import 'simplebar-react/dist/simplebar.min.css'

// https://github.com/mdbootstrap/perfect-scrollbar
// https://github.com/goldenyz/react-perfect-scrollbar

function PageScroll(props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-scroll-container', props.classContainer),
    style: props.height ? {
      height: props.height
    } : undefined
  }, /*#__PURE__*/React.createElement(_simplebarReact.default, {
    ref: ref,
    className: (0, _utils.clsNames)('un-scroll', props.className)
  }, props.wait && /*#__PURE__*/React.createElement(_Wait.default, null), props.children));
}
var _default = /*#__PURE__*/React.forwardRef(PageScroll);
exports.default = _default;